import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, verifyPassword, bindAccount, saveAccessInfo } from './modules'
import { removeSalt, languageChange, getSalt } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const AccountManage = Loadable({
    loader: () => import('./AccountManage'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          oauthAccountManageState: state.oauthAccountManageState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          removeSalt,
          verifyPassword,
          bindAccount,
          saveAccessInfo,
          languageChange,
          getSalt
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/account-manage`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AccountManage {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
